<ng-container>
  <div class="colors">
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[0]"
        [style.background]="colors[0]"
        (colorPickerChange)="setColor($event, 0)"
      />
      <span [style.color]="colors[0]">{{colors[0]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[1]"
        [style.background]="colors[1]"
        (colorPickerChange)="setColor($event, 1)"
      />
      <span [style.color]="colors[1]">{{colors[1]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[2]"
        [style.background]="colors[2]"
        (colorPickerChange)="setColor($event, 2)"
      />
      <span [style.color]="colors[2]">{{colors[2]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[3]"
        [style.background]="colors[3]"
        (colorPickerChange)="setColor($event, 3)"
      />
      <span [style.color]="colors[3]">{{colors[3]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[4]"
        [style.background]="colors[4]"
        (colorPickerChange)="setColor($event, 4)"
      />
      <span [style.color]="colors[4]">{{colors[4]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[5]"
        [style.background]="colors[5]"
        (colorPickerChange)="setColor($event, 5)"
      />
      <span [style.color]="colors[5]">{{colors[5]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[6]"
        [style.background]="colors[6]"
        (colorPickerChange)="setColor($event, 6)"
      />
      <span [style.color]="colors[6]">{{colors[6]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[7]"
        [style.background]="colors[7]"
        (colorPickerChange)="setColor($event, 7)"
      />
      <span [style.color]="colors[7]">{{colors[7]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[8]"
        [style.background]="colors[8]"
        (colorPickerChange)="setColor($event, 8)"
      />
      <span [style.color]="colors[8]">{{colors[8]}}</span>
    </div>
    <div>
      <input
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colors[9]"
        [style.background]="colors[9]"
        (colorPickerChange)="setColor($event, 9)"
      />
      <span [style.color]="colors[9]">{{colors[9]}}</span>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <button type="button" class="btn mx-2" [disabled]="!updatingColors" (click)="cancelConfigureColors()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="!updatingColors" (click)="configureColors()">Update Theme Palette</button>
  </div>
</ng-container>
